import React from "react";
import PropTypes from "prop-types";
import ReactSelect from "./ReactSelect";
import { isEmpty } from "lodash";

class BrandsBulkForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: [],
      total: 0,
    };
  }

  componentDidMount() {
    if (this.props.data) {
      const total = this.props.data.reduce((prev, current) => {
        return prev + parseFloat(current.revenue_share);
      }, 0);
      this.setState({ dataSource: this.props.data, total });
    }
  }

  editCell = (value, index, columnId) => {
    const rows = this.state.dataSource;
    rows[index][columnId] = value;
    this.setState({ dataSource: rows });
  };


  onRowReorder = ({ data, dragRowIndex, insertRowIndex }) => {
    let newData = [...dataSource];
    newData.splice(dragRowIndex, 1);
    newData.splice(insertRowIndex, 0, data);

    this.setState({ dataSource: newData });
  };

  addRow = () => {
    const rows = this.state.dataSource;
    rows.push({ name: null });

    this.setState({ dataSource: rows });
  };

  saveState = () => {
    const valueEl = document.getElementById(this.props.value_id);
    const formEl = document.getElementById(this.props.form_id);
    valueEl.value = JSON.stringify(this.state.dataSource);
    formEl.submit();
  };

  render() {
    return (
      <>
        <div className="sm:flex sm:items-center sm:justify-between">
          <button className="secondary-btn" onClick={this.addRow}>
            Add a row
          </button>
        </div>

        <div className="flex flex-col">
          <div className="-my-2 sm:-mx-6 lg:-mx-8">
            <div className="py-2 my-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div className="my-4 border border-gray-200 ">
                <table className="min-w-full table-fixed divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        className="px-6 py-3 w-1/4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Brand
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 w-1/4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        My Brand
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 w-1/4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Order
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 w-1/4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Last Updated
                      </th>
                    </tr>
                  </thead>

                  <tbody className="bg-white divide-y divide-gray-200">
                    {this.state.dataSource.map((row, index) => {
                      return (
                        <tr key={index}>
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                            {isEmpty(row.name) ? (
                              <>
                              <ReactSelect
                                className="brandsSelect"
                                options={this.props.brands}
                                field='brand_buffered_id' 
                                id={row.buffered_id}
                                changeHandler={(e) =>
                                  this.editCell(e.value, index, "buffered_id")
                                }
                              />
                              <div style={{ display: "none"}} id="brand_buffered_id"></div>
                              </>
                            ) : (
                              <span>{row.name}</span>
                            )}
                          </td>

                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                            <label aria-label="my brand" className="md_checkbox">
                              <input type="checkbox" checked={row.mybrand} onChange={(e) =>
                                  this.editCell(e.target.checked, index, "mybrand")} />
                              <span className="md_checkbox__tick"></span>
                            </label>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                            <input
                              id="order"
                              type="number"
                              defaultValue={row.order}
                              onChange={(e) =>
                                this.editCell(e.target.value, index, "order")
                              }
                            />
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                            {row.updated_at}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div className="w-2/4 pl-6 float-right sm:flex sm:items-center sm:justify-end">
                <button className="btn" onClick={this.saveState}>
                  Update Brands
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

BrandsBulkForm.propTypes = {
  data: PropTypes.array,
  brands: PropTypes.array,
};

export default BrandsBulkForm;
